import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";
import CustomTags from "../../Core/Components/CustomTags";
import { homeKpis } from "./Data/HomeData";
import { PERMISSIONS, TENANT_PERMISSIONS } from "../Login/constants";
import ChevronIcon from "../../Common/Svgs/ChevronIcon";
import { LockIcon } from "../../Common/Svgs/LockIcon";

const ModuleKPIs = () => {
  const navigate = useNavigate();

  const { userDetails } = useSelector((state) => state.loggedInUser);
  const { kpiData } = useSelector((state) => state.home);

  const [showTooltip, setShowTooltip] = useState(0);

  const getPermissions = (module) => {
    let tenantPermission = false;
    let userPermission = false;

    switch (module) {
      case "trikes": {
        tenantPermission = userDetails?.tenantPermissions?.includes(
          TENANT_PERMISSIONS.TRIKE_MODULE_ACCESS,
        );

        userPermission =
          userDetails?.permissions?.includes(PERMISSIONS.TRIKE_VIEW) ||
          userDetails?.permissions?.includes(PERMISSIONS.TRIKE_VIEW_AND_EDIT);

        break;
      }

      case "batteries": {
        tenantPermission = userDetails?.tenantPermissions?.includes(
          TENANT_PERMISSIONS.BATTERY_MODULE_ACCESS,
        );

        userPermission =
          userDetails?.permissions?.includes(PERMISSIONS.BATTERY_VIEW) ||
          userDetails?.permissions?.includes(PERMISSIONS.BATTERY_VIEW_AND_EDIT);

        break;
      }

      case "drivers": {
        tenantPermission = userDetails?.tenantPermissions?.includes(
          TENANT_PERMISSIONS.DRIVER_MODULE_ACCESS,
        );

        userPermission =
          userDetails?.permissions?.includes(PERMISSIONS.DRIVER_VIEW) ||
          userDetails?.permissions?.includes(PERMISSIONS.DRIVER_VIEW_AND_EDIT);

        break;
      }

      case "partners": {
        tenantPermission = userDetails?.tenantPermissions?.includes(
          TENANT_PERMISSIONS.PARTNER_MODULE_ACCESS,
        );

        userPermission =
          userDetails?.permissions?.includes(PERMISSIONS.PARTNER_VIEW) ||
          userDetails?.permissions?.includes(PERMISSIONS.PARTNER_VIEW_AND_EDIT);

        break;
      }

      default:
        break;
    }

    return { tenantPermission, userPermission };
  };

  return (
    <div className="">
      <div className="flex items-start w-[calc(100vw-72px-24px-24px)] max-h-max">
        {homeKpis(
          kpiData.trikes,
          kpiData.batteries,
          kpiData.drivers,
          kpiData.partners,
        ).map((item, index) => {
          const { tenantPermission, userPermission } = getPermissions(
            item.text,
          );

          // if (!tenantPermission) return <div />;

          return (
            <div
              role={userPermission && "button"}
              key={item.id}
              className={`w-full max-w-[24.8%] h-12 bg-white text-dark-grey-text shadow-button 
                font-poppins text-xs font-medium capitalize rounded-md relative ${
                  index !== 0 ? "ml-3" : ""
                }`}
              onClick={() => {
                // user should be able to visit the page only if permission exists
                if (userPermission) {
                  navigate(item.path);
                }
              }}
              onMouseEnter={() => {
                if (!tenantPermission) setShowTooltip(item.id);
              }}
              onMouseLeave={() => {
                if (!tenantPermission) setShowTooltip(0);
              }}
            >
              {!tenantPermission && (
                <div className="absolute z-20 w-full pt-4 flex items-center justify-center cursor-pointer">
                  <LockIcon size={18} className="text-dark-gray" />
                </div>
              )}

              {!tenantPermission && item.id === showTooltip && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  className="absolute -top-11 left-[20%] 2xl:left-[30%] bg-black px-3 py-2 rounded-md"
                >
                  <p className="font-poppins text-xs font-medium text-white">
                    Permission does not exist
                  </p>
                  <div className="absolute left-1/2 -bottom-2 -translate-x-1/2 w-0 h-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-t-black" />
                </motion.div>
              )}

              <div
                className="w-full h-full p-3"
                style={{ filter: !tenantPermission && "blur(1.5px)" }}
              >
                <div className="flex items-center justify-around w-full gap-x-4">
                  <CustomTags colors={item.color} width="full" size={homeKpis}>
                    <div className="flex items-center justify-start gap-x-2">
                      {item.icon}
                      <p className="text-xs font-semibold capitalize font-aileron">
                        {item.text}
                      </p>

                      {userPermission && (
                        <ChevronIcon
                          className={`w-3 h-3 ${item.chevronColor}`}
                        />
                      )}
                    </div>
                  </CustomTags>

                  <div className="text-base text-black font-poppins">
                    {item.total}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ModuleKPIs;
